var map = {
	"./dock/default/dock_base.png": 96019,
	"./fort/default/fort_base.png": 39219,
	"./pearl/default/pearl_base.png": 38065,
	"./sale/default/sale_base.png": 56354,
	"./saloon/default/saloon_base.png": 89557
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 65590;